import './styles.scss';
import './js/list-switch.js';
import './js/read-all-switch.js';
import './js/gallery.js';
import './js/newsletter.js';
import './js/single-release.js';
import './js/components/Player/PlayerApp.jsx';
import * as Turbo from "@hotwired/turbo";
//import './js/slider.js';

var previousPageUrl = null;
var _paq = _paq || [];

document.addEventListener('turbo:load', function(event) {
    if (previousPageUrl) {
        _paq.push(['setReferrerUrl', previousPageUrl]);
        _paq.push(['setCustomUrl', window.location.href]);
        _paq.push(['setDocumentTitle', document.title]);
        if (event.data && event.data.timing) {
            _paq.push(['setGenerationTimeMs', event.data.timing.visitEnd - event.data.timing.visitStart]);
        }
        _paq.push(['trackPageView']);
    }
    previousPageUrl = window.location.href;
});

/*
function _calculateCaptionWidth() {

    const imageWrapperItems = document.querySelectorAll(".image-wrapper");

    if(imageWrapperItems){
        imageWrapperItems.forEach((imageWrapperItem) => {
            let imageItem = imageWrapperItem.firstElementChild;
            if(imageItem){
                let imageItemWidth = imageItem.clientWidth;
                let captionItem = imageItem.nextElementSibling;
                if(captionItem){
                    captionItem.style.width = imageItemWidth + 'px';
                }
            }
        });
    }
}

window.addEventListener('resize', _calculateCaptionWidth, false);
document.addEventListener('DOMContentLoaded', _calculateCaptionWidth, false);
window.addEventListener('load', _calculateCaptionWidth);

Promise.all(Array.from(document.images).map(img => {
    if (img.complete)
        return Promise.resolve(img.naturalHeight !== 0);
    return new Promise(resolve => {
        img.addEventListener('load', () => resolve(true));
        img.addEventListener('error', () => resolve(false));
    });
})).then(results => {
    if (results.every(res => res)) {
        console.log('all images loaded successfully');
        _calculateCaptionWidth();
    } else {
        console.log('some images failed to load, all finished loading');
        _calculateCaptionWidth();
    }
});
*/